/**
 * Компонент 1: UI Shell (Map Adapter)
 * Соединяет существующий DOM/UI с новой Event Bus архитектурой.
 * AIDEV-OPTIMIZED: debounced filter emit, cached DOM refs
 */
(function() {
  'use strict';

  const API_BASE = window.location.origin;

  // ── HTML escaping for XSS prevention ───────────────────────────
  function escapeHtml(text) {
    if (text == null) return '';
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ── Favorites constants ────────────────────────────────────────
  const FAVORITES_KEY = 'webmap_favorites_data';
  const STAR_OUTLINE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9.153 5.408C10.42 3.136 11.053 2 12 2c.947 0 1.58 1.136 2.847 3.408l.327.588c.36.646.54.969.821 1.182.28.213.63.292 1.329.45l.636.144c2.46.557 3.69.835 3.982 1.776.293.94-.545 1.921-2.222 3.882l-.434.507c-.476.557-.715.836-.822 1.18-.107.345-.071.717 0 1.461l.066.677c.253 2.616.38 3.924-.387 4.506-.766.582-1.918.052-4.22-1.008l-.596-.274c-.654-.301-.981-.452-1.328-.452-.347 0-.674.15-1.328.452l-.597.274c-2.302 1.06-3.454 1.59-4.22 1.008-.766-.582-.64-1.89-.386-4.506l.065-.677c.072-.744.108-1.116 0-1.461-.107-.345-.346-.624-.822-1.18l-.434-.507C2.603 11.47 1.765 10.488 2.057 9.547c.293-.94 1.523-1.219 3.982-1.776l.637-.144c.698-.158 1.048-.237 1.328-.45.28-.213.46-.536.82-1.182z"/></svg>';
  const STAR_FILLED = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M9.153 5.408C10.42 3.136 11.053 2 12 2c.947 0 1.58 1.136 2.847 3.408l.327.588c.36.646.54.969.821 1.182.28.213.63.292 1.329.45l.636.144c2.46.557 3.69.835 3.982 1.776.293.94-.545 1.921-2.222 3.882l-.434.507c-.476.557-.715.836-.822 1.18-.107.345-.071.717 0 1.461l.066.677c.253 2.616.38 3.924-.387 4.506-.766.582-1.918.052-4.22-1.008l-.596-.274c-.654-.301-.981-.452-1.328-.452-.347 0-.674.15-1.328.452l-.597.274c-2.302 1.06-3.454 1.59-4.22 1.008-.766-.582-.64-1.89-.386-4.506l.065-.677c.072-.744.108-1.116 0-1.461-.107-.345-.346-.624-.822-1.18l-.434-.507C2.603 11.47 1.765 10.488 2.057 9.547c.293-.94 1.523-1.219 3.982-1.776l.637-.144c.698-.158 1.048-.237 1.328-.45.28-.213.46-.536.82-1.182z"/></svg>';

  // ── Cached DOM refs ────────────────────────────────────────────
  const _dom = {};
  function cacheDom() {
    const ids = [
      'filter-min-price', 'filter-max-price',
      'ad_type_auction_sale', 'ad_type_auction_rent',
      'ad_type_direct_sale', 'ad_type_lease_transfer', 'ad_type_ips',
      'filter-actual-only',
      'filter-data-mode',
      'filter-history-from-month', 'filter-history-from-year',
      'filter-history-to-month', 'filter-history-to-year',
      'lots-filter-reset', 'filter-permitted-use-container', 'filter-region-container'
    ];
    ids.forEach(function(id) {
      _dom[id] = document.getElementById(id);
    });
  }
  cacheDom();

  // ── Map ready ──────────────────────────────────────────────────
  window.addEventListener('map:ready', function() {
    const ml = document.getElementById('map-loader');
    if (ml) ml.classList.add('hidden');
  });

  window.addEventListener('map:error', function(e) {
    console.error('[UI] Map error:', e.detail);
  });

  // ── Layer / Overlay switcher ───────────────────────────────────
  (function setupLayerSwitcher() {
    const buttons = document.querySelectorAll('#layers-secondary-menu .menu-item-secondary');
    if (!buttons.length) return;

    // Default state: polygon overlay is on
    if (window._polygonsVisible !== false) {
      buttons.forEach(function(b) {
        if (b.dataset.layer === 'polygons') b.classList.add('active');
      });
    }

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const layerType = this.dataset.layer;
        if (!layerType) return;
        // Block only until the initial map load is complete. After that the menu
        // must react instantly, even if the previous base layer is still fetching tiles.
        if (!window.map || !window.__mapInitialLoadComplete) return;

        if (layerType === 'cadastre' || layerType === 'polygons' || layerType.startsWith('nspd-') || layerType.startsWith('mapru-')) {
          const visible = !this.classList.contains('active');
          this.classList.toggle('active');
          if (layerType === 'polygons') {
            window.dispatchEvent(new CustomEvent('polygons:toggle', {
              detail: { visible: visible }
            }));
          } else {
            window.dispatchEvent(new CustomEvent('overlay:toggle', {
              detail: { overlayId: layerType, visible: visible }
            }));
          }
          return;
        }

        // Base layer
        window.dispatchEvent(new CustomEvent('layer:switch', {
          detail: { layerId: layerType }
        }));

        buttons.forEach(function(b) {
          if (b.dataset.layer === layerType) b.classList.add('active');
          else if (b.dataset.layer && b.dataset.layer !== 'cadastre' && b.dataset.layer !== 'polygons' && !b.dataset.layer.startsWith('nspd-') && !b.dataset.layer.startsWith('mapru-')) b.classList.remove('active');
        });
      });
    });
  })();

  // ── Filters ────────────────────────────────────────────────────
  (function setupFilters() {
    let _filterDebounce = null;

    function isAuthForFilters() {
      if (typeof window.goszemlyaAuth === 'object' && typeof window.goszemlyaAuth.isAuthenticated === 'function') {
        return window.goszemlyaAuth.isAuthenticated();
      }
      return false;
    }

    function populateHistorySelectors() {
      const months = [
        { v: '01', n: 'Январь' }, { v: '02', n: 'Февраль' }, { v: '03', n: 'Март' },
        { v: '04', n: 'Апрель' }, { v: '05', n: 'Май' }, { v: '06', n: 'Июнь' },
        { v: '07', n: 'Июль' }, { v: '08', n: 'Август' }, { v: '09', n: 'Сентябрь' },
        { v: '10', n: 'Октябрь' }, { v: '11', n: 'Ноябрь' }, { v: '12', n: 'Декабрь' }
      ];
      const now = new Date();
      const currentYear = now.getFullYear();
      const years = [];
      for (let y = currentYear - 5; y <= currentYear + 1; y++) years.push(y);

      ['from', 'to'].forEach(function(dir) {
        const mEl = _dom['filter-history-' + dir + '-month'];
        const yEl = _dom['filter-history-' + dir + '-year'];
        if (!mEl || !yEl) return;
        mEl.innerHTML = months.map(function(m) {
          return '<option value="' + m.v + '">' + m.n + '</option>';
        }).join('');
        yEl.innerHTML = years.map(function(y) {
          return '<option value="' + y + '">' + y + '</option>';
        }).join('');
      });

      // Default: previous month - current month
      const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const fm = _dom['filter-history-from-month'];
      const fy = _dom['filter-history-from-year'];
      const tm = _dom['filter-history-to-month'];
      const ty = _dom['filter-history-to-year'];
      if (fm) fm.value = String(prev.getMonth() + 1).padStart(2, '0');
      if (fy) fy.value = String(prev.getFullYear());
      if (tm) tm.value = String(now.getMonth() + 1).padStart(2, '0');
      if (ty) ty.value = String(now.getFullYear());
    }

    function getHistoryValue(dir) {
      const mEl = _dom['filter-history-' + dir + '-month'];
      const yEl = _dom['filter-history-' + dir + '-year'];
      if (!mEl || !yEl) return null;
      const m = mEl.value;
      const y = yEl.value;
      if (!m || !y) return null;
      return y + '-' + m;
    }

    function isHistoricalMode() {
      const modeEl = _dom['filter-data-mode'];
      return modeEl ? modeEl.value === 'historical' : false;
    }

    function updateDataModeUI() {
      const authed = isAuthForFilters();
      const historical = isHistoricalMode();
      const historySection = document.getElementById('filter-history-section');
      const modeEl = _dom['filter-data-mode'];

      // Sync the hidden checkbox used by marker/polygon modules.
      const actualOnlyEl = _dom['filter-actual-only'];
      if (actualOnlyEl) actualOnlyEl.checked = !historical;

      // History period controls are only visible for authorized users in historical mode.
      if (historySection) {
        historySection.style.display = (authed && historical) ? '' : 'none';
      }

      // Data mode switch is only useful for authorized users.
      if (modeEl) modeEl.disabled = !authed;

      // When not authorized, force actual mode.
      if (!authed) {
        if (modeEl) modeEl.value = 'actual';
        if (actualOnlyEl) actualOnlyEl.checked = true;
      }
    }

    function updateAuthFiltersVisibility() {
      const authed = isAuthForFilters();
      document.querySelectorAll('.auth-only-filter').forEach(function(el) {
        el.style.display = authed ? '' : 'none';
      });
      const ipsEl = _dom['ad_type_ips'];
      if (ipsEl) ipsEl.checked = false;
      updateDataModeUI();
    }

    function emitFilterChange() {
      clearTimeout(_filterDebounce);
      _filterDebounce = setTimeout(function() {
        const adMap = {
          ad_type_auction_sale: 'auction_sale',
          ad_type_auction_rent: 'auction_rent',
          ad_type_direct_sale: 'direct_sale',
          ad_type_lease_transfer: 'lease_transfer',
          ad_type_ips: 'ips'
        };
        const adTypes = [];
        for (const [id, val] of Object.entries(adMap)) {
          const el = _dom[id];
          if (el && el.checked) adTypes.push(val);
        }

        const minPriceEl = _dom['filter-min-price'];
        const maxPriceEl = _dom['filter-max-price'];
        const actualOnlyEl = _dom['filter-actual-only'];
        const actualOnly = actualOnlyEl ? actualOnlyEl.checked : true;
        const historyFrom = actualOnly ? null : getHistoryValue('from');
        const historyTo = actualOnly ? null : getHistoryValue('to');

        const puContainer = document.getElementById('filter-permitted-use-container');
        const permittedUseEls = document.querySelectorAll('#filter-permitted-use-container input[type="checkbox"].vri-option:checked');
        const permittedUses = [];
        permittedUseEls.forEach(function(el) { permittedUses.push(el.value); });
        const allVriCount = puContainer ? parseInt(puContainer.dataset.vriCount || '0', 10) : 0;

        const regionContainer = document.getElementById('filter-region-container');
        const regionEls = document.querySelectorAll('#filter-region-container input[type="checkbox"].region-option:checked');
        const regions = [];
        regionEls.forEach(function(el) { regions.push(el.value); });
        const allRegionCount = regionContainer ? parseInt(regionContainer.dataset.regionCount || '0', 10) : 0;

        // Default ad-type selection is the four non-IPS types; IPS is opt-in.
        const defaultAdTypes = ['auction_sale', 'auction_rent', 'direct_sale', 'lease_transfer'];
        const isDefaultAdTypes = adTypes.length === defaultAdTypes.length &&
          defaultAdTypes.every(function(t) { return adTypes.indexOf(t) !== -1; });
        const filterDetail = {
          adTypes: isDefaultAdTypes ? null : adTypes,
          minPrice: minPriceEl && minPriceEl.value ? parseFloat(minPriceEl.value) : null,
          maxPrice: maxPriceEl && maxPriceEl.value ? parseFloat(maxPriceEl.value) : null,
          actualOnly: actualOnly,
          historyFrom: historyFrom,
          historyTo: historyTo,
          permittedUses: permittedUses.length === allVriCount ? null : permittedUses,
          regions: regions.length === allRegionCount ? null : regions
        };
        try {
          sessionStorage.setItem('webmap_filters', JSON.stringify(filterDetail));
        } catch (e) {}
        window.dispatchEvent(new CustomEvent('filter:change', { detail: filterDetail }));
        updateListingsMenuLink();
        updateMapUrl();
        updateResetButtonVisibility();
      }, 300);
    }

    function buildFilterQuery() {
      const params = new URLSearchParams();

      const adMap = {
        ad_type_auction_sale: 'auction_sale',
        ad_type_auction_rent: 'auction_rent',
        ad_type_direct_sale: 'direct_sale',
        ad_type_lease_transfer: 'lease_transfer',
        ad_type_ips: 'ips'
      };
      const adTypes = [];
      for (const [id, val] of Object.entries(adMap)) {
        const el = _dom[id];
        if (el && el.checked) adTypes.push(val);
      }
      // Default ad-type selection is the four non-IPS types; IPS is opt-in.
      const defaultAdTypes = ['auction_sale', 'auction_rent', 'direct_sale', 'lease_transfer'];
      const isDefault = adTypes.length === defaultAdTypes.length &&
        defaultAdTypes.every(function(t) { return adTypes.indexOf(t) !== -1; });
      if (adTypes.length > 0 && !isDefault) {
        params.set('ad_type', adTypes.join(','));
      }

      const actualOnlyEl = _dom['filter-actual-only'];
      const actualOnly = actualOnlyEl ? actualOnlyEl.checked : true;
      if (isAuthForFilters() && !actualOnly) {
        params.set('actual_only', 'false');
        const from = getHistoryValue('from');
        const to = getHistoryValue('to');
        if (from) params.set('history_from', from);
        if (to) params.set('history_to', to);
      }

      const minPriceEl = _dom['filter-min-price'];
      const maxPriceEl = _dom['filter-max-price'];
      if (minPriceEl && minPriceEl.value) params.set('min_price', minPriceEl.value);
      if (maxPriceEl && maxPriceEl.value) params.set('max_price', maxPriceEl.value);

      const puContainer = document.getElementById('filter-permitted-use-container');
      const allVriCount = puContainer ? parseInt(puContainer.dataset.vriCount || '0', 10) : 0;
      const checkedVri = [];
      document.querySelectorAll('#filter-permitted-use-container input.vri-option:checked').forEach(function(el) { checkedVri.push(el.value); });
      if (checkedVri.length > 0 && checkedVri.length < allVriCount) params.set('vri', checkedVri.join(','));

      const regionContainer = document.getElementById('filter-region-container');
      const allRegionCount = regionContainer ? parseInt(regionContainer.dataset.regionCount || '0', 10) : 0;
      const checkedRegions = [];
      document.querySelectorAll('#filter-region-container input.region-option:checked').forEach(function(el) { checkedRegions.push(el.value); });
      if (checkedRegions.length > 0 && checkedRegions.length < allRegionCount) params.set('region', checkedRegions.join(','));

      const q = params.toString();
      return q ? '?' + q : '';
    }

    function updateListingsMenuLink() {
      const query = buildFilterQuery();
      document.querySelectorAll('.menu-item[href="/obyavleniya"]').forEach(function(link) {
        link.href = '/obyavleniya' + query;
      });
    }

    function navigateToListings() {
      // Filters are persisted in sessionStorage, so navigate without query string
      // to avoid URL length limits. /obyavleniya will restore filters from storage.
      window.location.href = '/obyavleniya';
    }

    function updateMapUrl() {
      const query = buildFilterQuery();
      const newUrl = window.location.pathname + query + window.location.hash;
      if (window.location.pathname + window.location.search + window.location.hash !== newUrl) {
        window.history.replaceState({}, '', newUrl);
      }
    }

    function updateResetButtonVisibility() {
      const actionsRow = document.getElementById('filter-actions-row');
      if (!actionsRow) return;
      let isDefault = true;

      ['ad_type_auction_sale','ad_type_auction_rent','ad_type_direct_sale','ad_type_lease_transfer'].forEach(function(id) {
        const el = _dom[id];
        if (el && !el.checked) isDefault = false;
      });
      const ipsEl = _dom['ad_type_ips'];
      if (ipsEl && ipsEl.checked) isDefault = false;

      const dataModeEl = _dom['filter-data-mode'];
      if (dataModeEl && dataModeEl.value !== 'actual') isDefault = false;

      const now = new Date();
      const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const defaultFrom = String(prev.getFullYear()) + '-' + String(prev.getMonth() + 1).padStart(2, '0');
      const defaultTo = String(now.getFullYear()) + '-' + String(now.getMonth() + 1).padStart(2, '0');
      if (getHistoryValue('from') !== defaultFrom || getHistoryValue('to') !== defaultTo) isDefault = false;

      const minPriceEl = _dom['filter-min-price'];
      const maxPriceEl = _dom['filter-max-price'];
      if ((minPriceEl && minPriceEl.value) || (maxPriceEl && maxPriceEl.value)) isDefault = false;

      const puContainer = document.getElementById('filter-permitted-use-container');
      if (puContainer) {
        const all = parseInt(puContainer.dataset.vriCount || '0', 10);
        const checked = puContainer.querySelectorAll('input.vri-option:checked').length;
        if (checked !== all) isDefault = false;
      }

      const regionContainer = document.getElementById('filter-region-container');
      if (regionContainer) {
        const all = parseInt(regionContainer.dataset.regionCount || '0', 10);
        const checked = regionContainer.querySelectorAll('input.region-option:checked').length;
        if (checked !== all) isDefault = false;
      }

      actionsRow.style.display = isDefault ? 'none' : 'flex';
    }

    function refreshSelectAllStates() {
      [
        { prefix: 'filter-permitted-use', wrapperClass: 'vri-option-wrapper' },
        { prefix: 'filter-region', wrapperClass: 'region-option-wrapper' }
      ].forEach(function(cfg) {
        const listEl = document.getElementById(cfg.prefix + '-list');
        const selectAllEl = document.getElementById(cfg.prefix + '-select-all');
        if (!listEl || !selectAllEl) return;
        const wrappers = listEl.querySelectorAll('.' + cfg.wrapperClass);
        let visible = 0, checked = 0;
        wrappers.forEach(function(w) {
          if (w.style.display === 'none') return;
          visible++;
          const cb = w.querySelector('input[type="checkbox"]');
          if (cb && cb.checked) checked++;
        });
        selectAllEl.checked = visible > 0 && visible === checked;
        selectAllEl.indeterminate = checked > 0 && checked < visible;
      });
    }

    function getSessionFilters() {
      try {
        const raw = sessionStorage.getItem('webmap_filters');
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }

    function applyUrlFilters() {
      const params = new URLSearchParams(window.location.search);
      const session = !params.toString() ? getSessionFilters() : null;

      const adMap = {
        ad_type_auction_sale: 'auction_sale',
        ad_type_auction_rent: 'auction_rent',
        ad_type_direct_sale: 'direct_sale',
        ad_type_lease_transfer: 'lease_transfer',
        ad_type_ips: 'ips'
      };
      const adTypeParam = params.get('ad_type');
      const adTypes = session && Array.isArray(session.adTypes)
        ? session.adTypes
        : (adTypeParam ? adTypeParam.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : null);
      // null/undefined adTypes means "all types selected".
      const authed = isAuthForFilters();
      for (const key in adMap) {
        if (!adMap.hasOwnProperty(key)) continue;
        const el = _dom[key];
        if (!el) continue;
        if (key === 'ad_type_ips') {
          // IPS is opt-in for authorized users; default off
          el.checked = Array.isArray(adTypes) && adTypes.includes(adMap[key]) && authed;
          continue;
        }
        el.checked = !adTypes || adTypes.includes(adMap[key]);
      }

      const dataModeEl = _dom['filter-data-mode'];
      const actualOnlyEl = _dom['filter-actual-only'];
      let actualOnly = true;
      if (params.has('actual_only')) {
        actualOnly = params.get('actual_only') !== 'false';
      } else if (session && typeof session.actualOnly === 'boolean') {
        actualOnly = session.actualOnly;
      }
      if (dataModeEl) dataModeEl.value = actualOnly ? 'actual' : 'historical';
      if (actualOnlyEl) actualOnlyEl.checked = actualOnly;

      const historyFrom = params.get('history_from') || (session && session.historyFrom) || null;
      const historyTo = params.get('history_to') || (session && session.historyTo) || null;
      if (historyFrom && /^\d{4}-\d{2}$/.test(historyFrom)) {
        const [y, m] = historyFrom.split('-');
        const fm = _dom['filter-history-from-month'];
        const fy = _dom['filter-history-from-year'];
        if (fm) fm.value = m;
        if (fy) fy.value = y;
      }
      if (historyTo && /^\d{4}-\d{2}$/.test(historyTo)) {
        const [y, m] = historyTo.split('-');
        const tm = _dom['filter-history-to-month'];
        const ty = _dom['filter-history-to-year'];
        if (tm) tm.value = m;
        if (ty) ty.value = y;
      }

      const minPriceEl = _dom['filter-min-price'];
      const maxPriceEl = _dom['filter-max-price'];
      if (minPriceEl) minPriceEl.value = params.get('min_price') || (session ? String(session.minPrice || '') : '');
      if (maxPriceEl) maxPriceEl.value = params.get('max_price') || (session ? String(session.maxPrice || '') : '');

      const vriParam = params.get('vri');
      const vriList = session && Array.isArray(session.permittedUses)
        ? session.permittedUses
        : (vriParam !== null ? vriParam.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : null);
      if (vriList !== null) {
        document.querySelectorAll('#filter-permitted-use-container input.vri-option').forEach(function(el) {
          el.checked = vriList.includes(el.value);
        });
      }

      const regionParam = params.get('region');
      const regionList = session && Array.isArray(session.regions)
        ? session.regions
        : (regionParam !== null ? regionParam.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : null);
      if (regionList !== null) {
        document.querySelectorAll('#filter-region-container input.region-option').forEach(function(el) {
          el.checked = regionList.includes(el.value);
        });
      }

      updateDataModeUI();
    }

    const ids = [
      'filter-min-price', 'filter-max-price',
      'ad_type_auction_sale', 'ad_type_auction_rent',
      'ad_type_direct_sale', 'ad_type_lease_transfer', 'ad_type_ips',
      'filter-data-mode',
      'filter-history-from-month', 'filter-history-from-year',
      'filter-history-to-month', 'filter-history-to-year'
    ];
    ids.forEach(function(id) {
      const el = _dom[id];
      if (el) el.addEventListener('change', emitFilterChange);
    });

    // Data mode switch updates the hidden actual-only checkbox and visibility.
    const dataModeEl = _dom['filter-data-mode'];
    if (dataModeEl) {
      dataModeEl.addEventListener('change', function() {
        updateDataModeUI();
        emitFilterChange();
      });
    }

    const resetBtn = _dom['lots-filter-reset'];
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        ['ad_type_auction_sale','ad_type_auction_rent','ad_type_direct_sale','ad_type_lease_transfer'].forEach(function(id) {
          const el = _dom[id];
          if (el) el.checked = true;
        });
        const ipsEl = _dom['ad_type_ips'];
        if (ipsEl) ipsEl.checked = false;
        const dataModeEl = _dom['filter-data-mode'];
        if (dataModeEl) dataModeEl.value = 'actual';
        populateHistorySelectors();
        ['filter-min-price','filter-max-price'].forEach(function(id) {
          const el = _dom[id];
          if (el) el.value = '';
        });
        const puContainer = _dom['filter-permitted-use-container'];
        if (puContainer) {
          const searchEl = document.getElementById('filter-permitted-use-search');
          if (searchEl) searchEl.value = '';
          const listEl = document.getElementById('filter-permitted-use-list');
          if (listEl) {
            listEl.querySelectorAll('.vri-option-wrapper').forEach(function(w) { w.style.display = ''; });
            const noResultsEl = listEl.querySelector('.vri-no-results');
            if (noResultsEl) noResultsEl.style.display = 'none';
          }
          puContainer.querySelectorAll('input[type="checkbox"].vri-option').forEach(function(el) {
            el.checked = true;
          });
          const selectAllEl = document.getElementById('filter-permitted-use-select-all');
          if (selectAllEl) {
            selectAllEl.checked = true;
            selectAllEl.indeterminate = false;
          }
        }
        const regionContainer = _dom['filter-region-container'];
        if (regionContainer) {
          const searchEl = document.getElementById('filter-region-search');
          if (searchEl) searchEl.value = '';
          const listEl = document.getElementById('filter-region-list');
          if (listEl) {
            listEl.querySelectorAll('.region-option-wrapper').forEach(function(w) { w.style.display = ''; });
            const noResultsEl = listEl.querySelector('.region-no-results');
            if (noResultsEl) noResultsEl.style.display = 'none';
          }
          regionContainer.querySelectorAll('input[type="checkbox"].region-option').forEach(function(el) {
            el.checked = true;
          });
          const selectAllEl = document.getElementById('filter-region-select-all');
          if (selectAllEl) {
            selectAllEl.checked = true;
            selectAllEl.indeterminate = false;
          }
        }
        updateDataModeUI();
        updateAuthFiltersVisibility();
        refreshSelectAllStates();
        emitFilterChange();
        updateResetButtonVisibility();
      });
    }

    // ── VRI (permitted use) filters ────────────────────────────────
    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function(ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function getStaticVriList() {
      if (typeof VRI_CLASSIFIER !== 'undefined' && Array.isArray(VRI_CLASSIFIER)) {
        return VRI_CLASSIFIER.map(function(v) {
          const isOther = v.name === 'Иной вид';
          const value = isOther ? '__other__' : (v.code || '');
          const label = value && value !== '__other__' ? v.name + ' (' + v.code + ')' : v.name;
          return { value: value, label: label };
        }).filter(function(v) { return v.value; });
      }
      return [];
    }

    function renderVriFilters(uses) {
      const container = _dom['filter-permitted-use-container'];
      if (!container) return;
      if (!uses || !uses.length) {
        container.dataset.vriCount = String(uses.length);
      container.innerHTML = '<div style="color:#999;font-size:13px;padding:4px 0;">Нет данных</div>';
        return;
      }
      const otherItem = uses.find(function(u) { return u.value === '__other__'; });
      const knownUses = uses.filter(function(u) { return u.value !== '__other__'; });
      knownUses.sort(function(a, b) { return a.label.localeCompare(b.label, 'ru'); });
      if (otherItem) knownUses.unshift(otherItem);
      uses = knownUses;
      container.dataset.vriCount = String(uses.length);

      const toolsId = 'filter-permitted-use-tools';
      const searchId = 'filter-permitted-use-search';
      const selectAllId = 'filter-permitted-use-select-all';
      const listId = 'filter-permitted-use-list';

      container.innerHTML =
        '<div id="' + toolsId + '" style="display:flex;flex-direction:column;gap:6px;padding:4px 0 8px;border-bottom:1px solid #e9ecef;margin-bottom:6px;">' +
          '<div class="ad-checkbox-option" style="padding:3px 0;margin:0;background:transparent;">' +
            '<input type="checkbox" id="' + selectAllId + '">' +
            '<label for="' + selectAllId + '">Отметить все</label>' +
          '</div>' +
          '<input type="text" id="' + searchId + '" placeholder="Быстрый поиск ВРИ…" autocomplete="off" style="width:100%;padding:6px 10px;border:1px solid #dee2e6;border-radius:6px;font-size:13px;outline:none;color:#1a1a2e;background:#fff;">' +
        '</div>' +
        '<div id="' + listId + '" style="max-height:320px;overflow-y:auto;padding-right:4px;">' +
          uses.map(function(u, i) {
            const safeValue = escapeHtml(u.value);
            const safeLabel = escapeHtml(u.label);
            return '<div class="ad-checkbox-option vri-option-wrapper" style="padding:3px 0;" data-vri="' + safeLabel.replace(/"/g, '&quot;') + '">' +
              '<input type="checkbox" class="vri-option" id="filter_pu_' + i + '" value="' + safeValue.replace(/"/g, '&quot;') + '" checked>' +
              '<label for="filter_pu_' + i + '">' + safeLabel + '</label>' +
            '</div>';
          }).join('') +
          '<div class="vri-no-results" style="display:none;color:#999;font-size:13px;padding:4px 0;">Ничего не найдено</div>' +
        '</div>';

      const knownVriValues = uses.filter(function(u) { return u.value !== '__other__'; }).map(function(u) { return u.value; });
      container.dataset.knownVri = JSON.stringify(knownVriValues);

      const searchEl = document.getElementById(searchId);
      const selectAllEl = document.getElementById(selectAllId);
      const listEl = document.getElementById(listId);
      const noResultsEl = listEl.querySelector('.vri-no-results');

      function isVisible(w) {
        return w.style.display !== 'none';
      }

      function updateSelectAllState() {
        if (!listEl || !selectAllEl) return;
        let visibleCount = 0;
        let checkedVisibleCount = 0;
        listEl.querySelectorAll('.vri-option-wrapper').forEach(function(w) {
          if (!isVisible(w)) return;
          visibleCount++;
          const cb = w.querySelector('.vri-option');
          if (cb && cb.checked) checkedVisibleCount++;
        });
        selectAllEl.checked = visibleCount > 0 && visibleCount === checkedVisibleCount;
        selectAllEl.indeterminate = checkedVisibleCount > 0 && checkedVisibleCount < visibleCount;
      }

      if (searchEl) {
        searchEl.addEventListener('input', function() {
          const q = this.value.trim().toLowerCase();
          let visibleCount = 0;
          listEl.querySelectorAll('.vri-option-wrapper').forEach(function(w) {
            const text = (w.getAttribute('data-vri') || '').toLowerCase();
            const match = !q || text.indexOf(q) !== -1;
            w.style.display = match ? '' : 'none';
            if (match) visibleCount++;
          });
          if (noResultsEl) noResultsEl.style.display = visibleCount ? 'none' : 'block';
          updateSelectAllState();
        });
      }

      if (selectAllEl) {
        selectAllEl.addEventListener('change', function() {
          const checked = this.checked;
          listEl.querySelectorAll('.vri-option-wrapper').forEach(function(w) {
            if (!isVisible(w)) return;
            const cb = w.querySelector('.vri-option');
            if (cb) cb.checked = checked;
          });
          updateSelectAllState();
          emitFilterChange();
        });
      }

      listEl.querySelectorAll('.vri-option').forEach(function(el) {
        el.addEventListener('change', function() {
          updateSelectAllState();
          emitFilterChange();
        });
      });

      updateSelectAllState();
    }

    function getStaticRegionList() {
      if (typeof REGION_CODES !== 'undefined' && Array.isArray(REGION_CODES)) {
        return REGION_CODES.slice();
      }
      return [];
    }

    function renderRegionFilters(regions) {
      const container = _dom['filter-region-container'];
      if (!container) return;
      if (!regions || !regions.length) {
        container.dataset.regionCount = String(regions.length);
        container.innerHTML = '<div style="color:#999;font-size:13px;padding:4px 0;">Нет данных</div>';
        return;
      }
      regions.sort(function(a, b) { return a.name.localeCompare(b.name, 'ru'); });
      container.dataset.regionCount = String(regions.length);

      const toolsId = 'filter-region-tools';
      const searchId = 'filter-region-search';
      const selectAllId = 'filter-region-select-all';
      const listId = 'filter-region-list';

      container.innerHTML =
        '<div id="' + toolsId + '" style="display:flex;flex-direction:column;gap:6px;padding:4px 0 8px;border-bottom:1px solid #e9ecef;margin-bottom:6px;">' +
          '<div class="ad-checkbox-option" style="padding:3px 0;margin:0;background:transparent;">' +
            '<input type="checkbox" id="' + selectAllId + '">' +
            '<label for="' + selectAllId + '">Отметить все</label>' +
          '</div>' +
          '<input type="text" id="' + searchId + '" placeholder="Быстрый поиск региона…" autocomplete="off" style="width:100%;padding:6px 10px;border:1px solid #dee2e6;border-radius:6px;font-size:13px;outline:none;color:#1a1a2e;background:#fff;">' +
        '</div>' +
        '<div id="' + listId + '" style="max-height:320px;overflow-y:auto;padding-right:4px;">' +
          regions.map(function(r, i) {
            const safeCode = escapeHtml(r.code);
            const safeName = escapeHtml(r.name);
            return '<div class="ad-checkbox-option region-option-wrapper" style="padding:3px 0;" data-region="' + safeName.replace(/"/g, '&quot;') + '">' +
              '<input type="checkbox" class="region-option" id="filter_region_' + i + '" value="' + safeCode.replace(/"/g, '&quot;') + '" checked>' +
              '<label for="filter_region_' + i + '">' + safeName + '</label>' +
            '</div>';
          }).join('') +
          '<div class="region-no-results" style="display:none;color:#999;font-size:13px;padding:4px 0;">Ничего не найдено</div>' +
        '</div>';

      const searchEl = document.getElementById(searchId);
      const selectAllEl = document.getElementById(selectAllId);
      const listEl = document.getElementById(listId);
      const noResultsEl = listEl.querySelector('.region-no-results');

      function isVisible(w) {
        return w.style.display !== 'none';
      }

      function updateSelectAllState() {
        if (!listEl || !selectAllEl) return;
        let visibleCount = 0;
        let checkedVisibleCount = 0;
        listEl.querySelectorAll('.region-option-wrapper').forEach(function(w) {
          if (!isVisible(w)) return;
          visibleCount++;
          const cb = w.querySelector('.region-option');
          if (cb && cb.checked) checkedVisibleCount++;
        });
        selectAllEl.checked = visibleCount > 0 && visibleCount === checkedVisibleCount;
        selectAllEl.indeterminate = checkedVisibleCount > 0 && checkedVisibleCount < visibleCount;
      }

      if (searchEl) {
        searchEl.addEventListener('input', function() {
          const q = this.value.trim().toLowerCase();
          let visibleCount = 0;
          listEl.querySelectorAll('.region-option-wrapper').forEach(function(w) {
            const text = (w.getAttribute('data-region') || '').toLowerCase();
            const match = !q || text.indexOf(q) !== -1;
            w.style.display = match ? '' : 'none';
            if (match) visibleCount++;
          });
          if (noResultsEl) noResultsEl.style.display = visibleCount ? 'none' : 'block';
          updateSelectAllState();
        });
      }

      if (selectAllEl) {
        selectAllEl.addEventListener('change', function() {
          const checked = this.checked;
          listEl.querySelectorAll('.region-option-wrapper').forEach(function(w) {
            if (!isVisible(w)) return;
            const cb = w.querySelector('.region-option');
            if (cb) cb.checked = checked;
          });
          updateSelectAllState();
          emitFilterChange();
        });
      }

      listEl.querySelectorAll('.region-option').forEach(function(el) {
        el.addEventListener('change', function() {
          updateSelectAllState();
          emitFilterChange();
        });
      });

      updateSelectAllState();
    }

    // Load static VRI and region filters immediately (no API call)
    const vriContainer = _dom['filter-permitted-use-container'];
    if (vriContainer) {
      renderVriFilters(getStaticVriList());
    }
    const regionContainer = _dom['filter-region-container'];
    if (regionContainer) {
      renderRegionFilters(getStaticRegionList());
    }

    populateHistorySelectors();
    updateAuthFiltersVisibility();
    applyUrlFilters();
    refreshSelectAllStates();
    updateListingsMenuLink();
    updateResetButtonVisibility();
    if (window.location.pathname !== '/obyavleniya' && (window.location.search || getSessionFilters())) {
      emitFilterChange();
    }

    window.addEventListener('auth:change', function() {
      updateAuthFiltersVisibility();
      emitFilterChange();
    });
  })();

  // ── Geolocation button ─────────────────────────────────────────
  (function setupGeolocate() {
    const btn = document.querySelector('.menu-item[data-action="geolocate"]');
    if (btn) {
      btn.addEventListener('click', function() {
        window.dispatchEvent(new CustomEvent('ui:geolocate', {}));
      });
    }
  })();

  // ── 3D toggle button ───────────────────────────────────────────
  (function setup3DToggle() {
    const btn = document.querySelector('.menu-item-secondary[data-action="toggle-3d"]');
    if (!btn) return;
    let is3D = false;
    btn.addEventListener('click', function() {
      is3D = !is3D;
      btn.classList.toggle('active', is3D);
      window.dispatchEvent(new CustomEvent('3d:toggle', { detail: { enabled: is3D } }));
    });
  })();

  // ── Favorites helpers ──────────────────────────────────────────
  function getFavorites() {
    try {
      const raw = localStorage.getItem(FAVORITES_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        const obj = {};
        parsed.forEach(function(item) {
          if (item && item.lot_id) obj[item.lot_id] = item;
        });
        return obj;
      }
      return parsed || {};
    } catch (e) { return {}; }
  }
  function updateFavoritesIndicator() {
    const btn = document.querySelector('.menu-item[data-panel="favorites"]');
    if (btn) btn.classList.toggle('has-favorites', Object.keys(getFavorites()).length > 0);
  }

  function findLotForFavorite(lotId) {
    if (window._allLots && Array.isArray(window._allLots)) {
      const lot = window._allLots.find(function(l) { return String(l.lot_id) === String(lotId); });
      if (lot) return lot;
    }
    const initialLot = window.__INITIAL_LOT_DATA__;
    if (initialLot && String(initialLot.lot_id) === String(lotId)) {
      return initialLot;
    }
    return null;
  }

  window.toggleFavoriteLot = function(lotId) {
    const favorites = getFavorites();
    const isFav = !!favorites[lotId];
    if (favorites[lotId]) {
      delete favorites[lotId];
    } else {
      const lot = findLotForFavorite(lotId);
      if (lot) {
        favorites[lotId] = {
          lot_id: lot.lot_id, notice_number: lot.notice_number, price_min: lot.price_min,
          display_price: lot.display_price, type_transaction: lot.type_transaction,
          transaction_label: lot.transaction_label, bidd_form_name: lot.bidd_form_name,
          bidd_form_badge_class: lot.bidd_form_badge_class, transaction_badge_class: lot.transaction_badge_class,
          bidd_form_code: lot.bidd_form_code,
          cadastral_number: lot.cadastral_number, estate_address: lot.estate_address,
          final_lat: lot.final_lat, final_lon: lot.final_lon,
          bidd_end_time: lot.bidd_end_time, display_bidd_end_time: lot.display_bidd_end_time,
          rent_term: lot.rent_term, region_name: lot.region_name,
          foto_urls_json: lot.foto_urls_json, area: lot.area
        };
      }
    }
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    if (window.goszemlyaAnalytics && window.goszemlyaAnalytics.trackEvent) {
        window.goszemlyaAnalytics.trackEvent(isFav ? 'favorite_remove' : 'favorite_add', { lotId: String(lotId) });
    }
    if (window.syncFavoritesWithBackend) window.syncFavoritesWithBackend();
    const btn = document.querySelector('.lot-favorite-btn[data-lot-id="' + lotId + '"]');
    if (btn) {
      const isActive = !!favorites[lotId];
      btn.classList.toggle('active', isActive);
      btn.innerHTML = isActive ? STAR_FILLED : STAR_OUTLINE;
    }
    updateFavoritesIndicator();
    if (typeof window.renderFavoritesPanel === 'function') window.renderFavoritesPanel();
  };

  window.removeFavorite = function(lotId) {
    const favorites = getFavorites();
    delete favorites[lotId];
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    if (window.goszemlyaAnalytics && window.goszemlyaAnalytics.trackEvent) {
        window.goszemlyaAnalytics.trackEvent('favorite_remove', { lotId: String(lotId) });
    }
    if (window.syncFavoritesWithBackend) window.syncFavoritesWithBackend();
    updateFavoritesIndicator();
    const btn = document.querySelector('.lot-favorite-btn[data-lot-id="' + lotId + '"]');
    if (btn) { btn.classList.toggle('active', false); btn.innerHTML = STAR_OUTLINE; }
    if (typeof window.renderFavoritesPanel === 'function') window.renderFavoritesPanel();
  };

  async function refreshFavoritesData() {
    if (window._refreshingFavorites) return;
    window._refreshingFavorites = true;
    try {
      const favorites = getFavorites();
      const lotIds = Object.keys(favorites);
      if (lotIds.length === 0) return;
      const res = await fetch(API_BASE + '/api/lots?lot_ids=' + encodeURIComponent(lotIds.join(',')) + '&limit=' + lotIds.length);
      if (!res.ok) return;
      const data = await res.json();
      if (!data.items || !data.items.length) return;
      const updated = {};
      data.items.forEach(function(lot) {
        if (!lot || !lot.lot_id) return;
        updated[lot.lot_id] = {
          lot_id: lot.lot_id,
          notice_number: lot.notice_number,
          price_min: lot.price_min,
          display_price: lot.display_price,
          type_transaction: lot.type_transaction,
          transaction_label: lot.transaction_label,
          bidd_form_name: lot.bidd_form_name,
          bidd_form_code: lot.bidd_form_code,
          bidd_form_badge_class: lot.bidd_form_badge_class,
          transaction_badge_class: lot.transaction_badge_class,
          cadastral_number: lot.cadastral_number,
          estate_address: lot.estate_address,
          final_lat: lot.final_lat,
          final_lon: lot.final_lon,
          bidd_end_time: lot.bidd_end_time,
          display_bidd_end_time: lot.display_bidd_end_time,
          rent_term: lot.rent_term,
          region_name: lot.region_name,
          foto_urls_json: lot.foto_urls_json,
          area: lot.area
        };
      });
      const current = JSON.stringify(getFavorites());
      const next = JSON.stringify(updated);
      if (current !== next) {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(updated));
        window.renderFavoritesPanel();
      }
    } catch (err) {
      console.error('[UI] Failed to refresh favorites:', err);
    } finally {
      window._refreshingFavorites = false;
    }
  }
  window.refreshFavoritesData = refreshFavoritesData;

  if (typeof window.renderFavoritesPanel !== 'function') {
    window.renderFavoritesPanel = function() {
      const panel = document.getElementById('favorites-panel');
      if (!panel) return;
      const content = panel.querySelector('.panel-content') || panel.querySelector('.panel-body');
      if (!content) return;
      const favorites = getFavorites();
      const items = Object.values(favorites).filter(function(item) { return item && item.lot_id; });
      if (items.length === 0) {
        content.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#999;"><div style="font-size:48px;margin-bottom:16px;opacity:0.5;">⭐</div><p>Нет избранных мест</p></div>';
        return;
      }
      updateFavoritesIndicator();
      content.innerHTML = '<div class="favorites-list">' + items.map(function(item) {
        const lotIdJs = String(item.lot_id).replace(/'/g, "\\'");
        return '<div class="favorite-item" onclick="window.focusLotOnMap(\'' + lotIdJs + '\'); window.dispatchEvent(new CustomEvent(\'lot:select\', { detail: { lotId: \'' + lotIdJs + '\', source: \'favorites\' } }));">' +
          '<div class="favorite-item-header">' +
            '<span class="favorite-item-price">' + (item.display_price || (item.price_min ? item.price_min.toLocaleString('ru-RU') + ' ₽' : 'Цена не указана')) + '</span>' +
            '<button class="favorite-item-remove" onclick="event.stopPropagation(); window.removeFavorite(\'' + lotIdJs + '\')" title="Удалить">×</button>' +
          '</div>' +
          (item.cadastral_number ? '<div class="favorite-item-cadnum">' + item.cadastral_number + '</div>' : '') +
          '<div class="favorite-item-meta">' +
            (item.region_name ? '<span class="favorite-meta-tag">' + item.region_name + '</span>' : '') +
            (item.type_transaction === 'rent' ? '<span class="favorite-meta-tag">' + (item.rent_term || 'Срок не указан') + '</span>' : '') +
            '<span class="favorite-meta-tag">' + (item.bidd_form_name || '—') + '</span>' +
            '<span class="favorite-meta-tag">' + (item.transaction_label || (item.type_transaction === 'rent' ? 'Аренда' : item.type_transaction === 'sale' ? 'Продажа' : '—')) + '</span>' +
            (item.display_bidd_end_time ? '<span class="favorite-meta-tag favorite-meta-tag--deadline">' + item.display_bidd_end_time + '</span>' : '') +
          '</div>' +
        '</div>';
      }).join('') + '</div>';
      refreshFavoritesData();
    };
  }

  // ── Clipboard helper ───────────────────────────────────────────
  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
  }
  function showCopyToast(el) {
    let toast = el.querySelector('.lot-copy-toast');
    if (!toast) {
      toast = document.createElement('span');
      toast.className = 'lot-copy-toast';
      toast.textContent = 'Скопировано!';
      el.appendChild(toast);
    }
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 1500);
  }
  window.copyToClipboard = function(text, el) {
    if (!text) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() { showCopyToast(el); }).catch(function() { fallbackCopy(text); showCopyToast(el); });
    } else { fallbackCopy(text); showCopyToast(el); }
  };

  // ── Lightbox helpers ───────────────────────────────────────────
  window.openLightbox = function(index) {
    const photos = window._currentLightboxPhotos || [];
    if (!photos.length) return;
    window._lightboxIndex = index;
    const lb = document.getElementById('photo-lightbox');
    const img = document.getElementById('lightbox-img');
    if (lb && img) { img.src = API_BASE + '/storage/' + photos[index] + '?w=1200'; lb.style.display = 'flex'; }
  };
  window.lightboxPrev = function() {
    const photos = window._currentLightboxPhotos || [];
    if (!photos.length) return;
    window._lightboxIndex = (window._lightboxIndex - 1 + photos.length) % photos.length;
    const img = document.getElementById('lightbox-img');
    if (img) img.src = API_BASE + '/storage/' + photos[window._lightboxIndex] + '?w=1200';
  };
  window.lightboxNext = function() {
    const photos = window._currentLightboxPhotos || [];
    if (!photos.length) return;
    window._lightboxIndex = (window._lightboxIndex + 1) % photos.length;
    const img = document.getElementById('lightbox-img');
    if (img) img.src = API_BASE + '/storage/' + photos[window._lightboxIndex] + '?w=1200';
  };
  window.closeLightbox = function() {
    const lb = document.getElementById('photo-lightbox');
    if (lb) lb.style.display = 'none';
  };

  // ── Lot detail rendering ───────────────────────────────────────
  function formatPrice(val) {
    if (val == null || val <= 0) return '—';
    const n = Number(val);
    if (n >= 1e9) return (n / 1e9).toFixed(1).replace('.', ',') + ' млрд ₽';
    if (n >= 1e6) return (n / 1e6).toFixed(2).replace('.', ',') + ' млн ₽';
    if (n >= 1e3) return (n / 1e3).toFixed(0) + ' тыс. ₽';
    return n.toLocaleString('ru-RU') + ' ₽';
  }

  function isLotExpired(lot) {
    if (!lot || !lot.bidd_end_time) return false;
    const end = new Date(lot.bidd_end_time);
    return !isNaN(end.getTime()) && end.getTime() < Date.now();
  }

  function renderLotDetail(lot) {
    const headerEl = document.getElementById('lot-detail-header-info');
    const contentEl = document.getElementById('lot-detail-content');
    if (!headerEl || !contentEl) return;

    const favorites = getFavorites();
    const isFavorite = !!favorites[lot.lot_id];
    const priceText = lot.display_price || formatPrice(lot.price_min);

    // Normalize IPS form label and color
    const isIps = lot.bidd_form_code === 'IPS';
    const biddFormName = isIps ? 'Сообщение о реализации' : (lot.bidd_form_name || '—');
    const biddFormBadgeClass = isIps ? 'lot-badge--message' : (lot.bidd_form_badge_class || 'lot-badge--default');

    // Transaction badge: auction sale = blue, auction rent = green, IPS = orange
    let badgeClass, badgeText;
    if (isIps) {
      badgeClass = 'lot-badge--message';
      badgeText = lot.type_transaction === 'rent' ? 'Аренда' : lot.type_transaction === 'sale' ? 'Продажа' : (lot.transaction_label || '—');
    } else if (lot.bidd_form_code === 'EA') {
      badgeClass = lot.type_transaction === 'rent' ? 'lot-badge--rent' : 'lot-badge--sale';
      badgeText = lot.transaction_label || (lot.type_transaction === 'rent' ? 'Аренда' : 'Продажа');
    } else {
      badgeClass = lot.type_transaction === 'rent' ? 'lot-badge--rent-direct' : 'lot-badge--sale-direct';
      badgeText = lot.transaction_label || (lot.type_transaction === 'rent' ? 'Аренда' : 'Продажа');
    }

    // Header with favorite + copy link buttons
    headerEl.innerHTML = `
      <div style="display:flex;align-items:center;padding:8px 12px;gap:10px;">
        <div class="lot-premium-price" style="flex:1;min-width:0;">${escapeHtml(priceText)}</div>
        <button class="close-btn" onclick="closePanel('lot-detail-panel')">×</button>
      </div>
      <div style="display:flex;align-items:center;flex-wrap:nowrap;padding:0 12px 8px;gap:6px;">
        <span class="lot-badge ${biddFormBadgeClass}">${escapeHtml(biddFormName)}</span>
        <span class="lot-badge ${badgeClass}">${escapeHtml(badgeText)}</span>
        <div style="flex:1;min-width:0;"></div>
        <button class="lot-favorite-btn ${isFavorite ? 'active' : ''}" data-lot-id="${escapeHtml(lot.lot_id)}" onclick="window.toggleFavoriteLot('${String(lot.lot_id).replace(/'/g, "\\'")}')" title="Добавить в избранное">
          ${isFavorite ? STAR_FILLED : STAR_OUTLINE}
        </button>
        <button class="lot-favorite-btn" onclick="window.copyToClipboard('${window.location.origin}/lot/${encodeURIComponent(lot.cadastral_number || lot.lot_id || '')}', this)" title="Скопировать ссылку на объявление">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
        </button>
      </div>
    `;

    // Photos with lightbox
    const photos = Array.isArray(lot.foto_urls_json) ? lot.foto_urls_json : [];
    const photosHtml = photos.length
      ? `<div class="lot-premium-photos">${photos.slice(0,6).map(function(url, idx) {
          return '<div class="lot-premium-photo" onclick="window.openLightbox(' + idx + ')"><img src="' + escapeHtml(API_BASE + '/storage/' + url + '?w=800') + '" ' + (idx===0?'fetchpriority="high"':'loading="lazy"') + ' decoding="async"></div>';
        }).join('')}${photos.length > 6 ? '<div class="lot-premium-photo lot-premium-photo--more" onclick="window.openLightbox(0)">+' + (photos.length-6) + '</div>' : ''}</div>`
      : '';
    window._currentLightboxPhotos = photos;

    // Info grid
    let infoHtml = '';
    if (lot.cadastral_number) {
      infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Кадастровый номер</span><span class="lot-premium-value lot-premium-copy" onclick="window.copyToClipboard(\'' + escapeHtml(lot.cadastral_number).replace(/'/g, "\\'") + '\', this)">' + escapeHtml(lot.cadastral_number) + ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg></span></div>';
    }
    if (lot.area) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Площадь</span><span class="lot-premium-value">' + escapeHtml(lot.area) + ' м²</span></div>';
    if (lot.permitted_use) {
      const vriParts = lot.permitted_use.split(',').map(function(s){return s.trim()}).filter(Boolean);
      const vriHtml = vriParts.map(function(v) { return '<span class="vri-tag">' + escapeHtml(v) + '</span>'; }).join('');
      infoHtml += '<div class="lot-premium-row lot-premium-row--full"><span class="lot-premium-label">Вид разрешённого использования</span><span class="lot-premium-value">' + vriHtml + '</span></div>';
    }
    if (lot.category_name) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Категория</span><span class="lot-premium-value">' + escapeHtml(lot.category_name) + '</span></div>';
    if (lot.estate_address) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Адрес</span><span class="lot-premium-value">' + escapeHtml(lot.estate_address) + '</span></div>';
    if (lot.region_name) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Регион</span><span class="lot-premium-value">' + (lot.region_code ? '<a href="https://t.me/goszemlya' + escapeHtml(lot.region_code) + '" class="region-link" target="_blank" rel="noopener">' + escapeHtml(lot.region_name) + '</a>' : escapeHtml(lot.region_name)) + '</span></div>';
    if (lot.price_min != null && lot.price_min > 0) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Начальная цена</span><span class="lot-premium-value">' + escapeHtml(formatPrice(lot.price_min)) + '</span></div>';
    if (lot.nspd_cadastral_value != null && lot.nspd_cadastral_value > 0) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Кадастровая стоимость</span><span class="lot-premium-value">' + escapeHtml(formatPrice(lot.nspd_cadastral_value)) + '</span></div>';
    if (lot.rent_term) infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Срок аренды</span><span class="lot-premium-value">' + escapeHtml(lot.rent_term) + '</span></div>';
    if (lot.display_bidd_end_time) {
      const deadlineText = isLotExpired(lot) ? 'Завершен' : lot.display_bidd_end_time;
      infoHtml += '<div class="lot-premium-row"><span class="lot-premium-label">Приём заявок до</span><span class="lot-premium-value' + (isLotExpired(lot) ? ' lot-premium-value--expired' : '') + '">' + escapeHtml(deadlineText) + '</span></div>';
    }

    const torgiLink = lot.notice_number
      ? 'https://torgi.gov.ru/new/public/notices/view/' + encodeURIComponent(lot.notice_number)
      : null;
    const lotLink = 'https://torgi.gov.ru/new/public/lots/lot/' + encodeURIComponent(lot.lot_id);

    // Description for accordion
    function buildDescHtml(lot) {
      let h = '';
      if (lot.transaction_label) h += '<strong>Тип сделки:</strong> ' + escapeHtml(lot.transaction_label) + '<br>';
      const biddFormName = lot.bidd_form_code === 'IPS' ? 'Сообщение о реализации' : lot.bidd_form_name;
      if (biddFormName) h += '<strong>Форма торгов:</strong> ' + escapeHtml(biddFormName) + '<br>';
      if (lot.cadastral_number) h += '<strong>Кадастровый номер:</strong> ' + escapeHtml(lot.cadastral_number) + '<br>';
      if (lot.area) h += '<strong>Площадь:</strong> ' + escapeHtml(lot.area) + ' м²<br>';
      if (lot.permitted_use) {
        h += '<strong>Вид разрешённого использования:</strong> ' + escapeHtml(lot.permitted_use) + '<br>';
        const parts = lot.permitted_use.split(',').map(function(s){return s.trim()}).filter(Boolean);
        const descs = [];
        for (let i = 0; i < parts.length; i++) {
          const vd = typeof getVriDescription === 'function' ? getVriDescription(parts[i]) : '';
          if (vd) descs.push(vd);
        }
        if (descs.length) h += '<strong>Разрешено:</strong> ' + descs.map(function(d) { return escapeHtml(d); }).join('; ') + '<br>';
      }
      if (lot.category_name) h += '<strong>Категория земель:</strong> ' + escapeHtml(lot.category_name) + '<br>';
      if (lot.estate_address) h += '<strong>Адрес:</strong> ' + escapeHtml(lot.estate_address) + '<br>';
      if (lot.region_name) h += '<strong>Регион:</strong> ' + escapeHtml(lot.region_name) + '<br>';
      if (lot.price_min != null && lot.price_min > 0) h += '<strong>Начальная цена:</strong> ' + escapeHtml(formatPrice(lot.price_min)) + '<br>';
      if (lot.nspd_cadastral_value != null && lot.nspd_cadastral_value > 0) h += '<strong>Кадастровая стоимость:</strong> ' + escapeHtml(formatPrice(lot.nspd_cadastral_value)) + '<br>';
      if (lot.rent_term) h += '<strong>Срок аренды:</strong> ' + escapeHtml(lot.rent_term) + '<br>';
      if (lot.display_bidd_end_time) {
        const deadlineText = isLotExpired(lot) ? 'Завершен' : lot.display_bidd_end_time;
        h += '<strong>Приём заявок до:</strong> ' + escapeHtml(deadlineText) + '<br>';
      }
      if (lot.notice_number) h += '<strong>Номер извещения:</strong> ' + escapeHtml(lot.notice_number) + '<br>';
      return h;
    }
    const descHtml = buildDescHtml(lot);

    contentEl.innerHTML = `
      <div class="lot-premium">
        <div class="lot-premium-body">
          <div class="lot-premium-section">
            <div class="lot-premium-section-title">Информация об участке</div>
            <div class="lot-premium-grid">${infoHtml}</div>
          </div>
          ${photosHtml ? `
          <div class="lot-premium-section">
            <div class="lot-premium-section-title">Фотографии</div>
            ${photosHtml}
          </div>` : ''}
          <div class="lot-premium-section">
            <button class="lot-accordion-toggle open" type="button" onclick="var btn=this,body=btn.nextElementSibling;btn.classList.toggle('open');body.classList.toggle('open');">
              <span>Подробнее</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </button>
            <div class="lot-accordion-body open">
              <div class="lot-accordion-inner">
                <div class="lot-accordion-desc">
                  ${lot.estate_address ? '<strong>Адрес:</strong> ' + escapeHtml(lot.estate_address) + '<br><br>' : ''}${descHtml}
                </div>
                <div class="lot-action-buttons">
                  <a class="lot-action-btn" href="${lotLink}" target="_blank" rel="noopener">Лот</a>
                  ${torgiLink ? '<a class="lot-action-btn lot-action-btn--secondary" href="' + torgiLink + '" target="_blank" rel="noopener">Извещение</a>' : ''}
                </div>
                <div class="lot-vpn-notice">Выключите VPN для перехода на torgi.gov.ru</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    const panel = document.getElementById('lot-detail-panel');
    if (panel) {
      panel.classList.add('open');
      const overlay = document.getElementById('panel-overlay');
      if (overlay) overlay.classList.add('visible');
    }

    if (lot.seo_title) document.title = lot.seo_title;
    const h1El = document.getElementById('page-h1');
    if (h1El) h1El.textContent = lot.seo_h1 || (lot.transaction_label + ' ' + (lot.cadastral_number || lot.lot_id));
  }

  // ── Event: lot selected ────────────────────────────────────────
  window.addEventListener('lot:select', async function(e) {
    const lotId = e.detail && e.detail.lotId;
    if (!lotId) return;

    // Try to enrich from local cache
    let lot = null;
    if (window._allLots && Array.isArray(window._allLots)) {
      lot = window._allLots.find(function(l) { return String(l.lot_id) === String(lotId); });
    }

    // Use server-injected initial data if available and matches
    if (!lot && window.__INITIAL_LOT_DATA__) {
      const init = window.__INITIAL_LOT_DATA__;
      if (String(init.lot_id) === String(lotId) || String(init.cadastral_number) === String(lotId)) {
        lot = init;
      }
    }

    // Fetch full details if needed
    if (!lot || !lot.nspd_coordinates_json || !lot.estate_address) {
      try {
        const res = await fetch(API_BASE + '/api/lots?limit=1&lot_id=' + encodeURIComponent(lotId));
        if (res.ok) {
          const data = await res.json();
          if (data.items && data.items[0]) {
            lot = Object.assign({}, lot || {}, data.items[0]);
          }
        }
      } catch (err) {
        console.error('[UI] Failed to fetch lot details:', err);
      }
    }

    if (lot) renderLotDetail(lot);
  });

  // ── Backward compatibility stubs ───────────────────────────────
  window.showLotDetail = function(lot) {
    window.dispatchEvent(new CustomEvent('lot:select', { detail: { lotId: lot.lot_id, source: 'legacy' } }));
  };

  window.hideLotPopup = function() {
    window.dispatchEvent(new CustomEvent('lot:close', {}));
  };

  window.focusLotOnMap = function(lotId) {
    window.dispatchEvent(new CustomEvent('lot:focus', { detail: { lotId: lotId } }));
  };

  window.addEventListener('lot:close', function() {
    closePanel('lot-detail-panel');
  });

  // Cache DOM on script load (elements may not exist yet, but we'll try)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cacheDom);
  } else {
    cacheDom();
  }

  // ── Zoom indicator ─────────────────────────────────────────────
  window.addEventListener('map:ready', function(e) {
    const map = e.detail.map;
    const zoomDiv = document.getElementById('map-zoom-indicator');
    if (zoomDiv) {
      map.on('zoom', function() {
        zoomDiv.textContent = 'z' + map.getZoom().toFixed(1);
      });
    }
  });

  // ── Direct lot URL (/lot/:identifier) ──────────────────────────
  async function handleDirectLotUrl() {
    const match = window.location.pathname.match(/^\/lot\/([^/]+)$/);
    if (!match) return;
    const identifier = decodeURIComponent(match[1]);
    try {
      let lot = window.__INITIAL_LOT_DATA__ || null;
      // Validate that injected lot matches the URL identifier
      if (lot && String(lot.lot_id) !== identifier && String(lot.cadastral_number) !== identifier) {
        lot = null;
      }
      if (!lot) {
        const r1 = await fetch(API_BASE + '/api/lots/' + encodeURIComponent(identifier));
        if (r1.ok) lot = await r1.json();
      }
      if (!lot) {
        const r2 = await fetch(API_BASE + '/api/lots/by-kn?kn=' + encodeURIComponent(identifier));
        if (r2.ok) lot = await r2.json();
      }
      if (lot && lot.lot_id) {
        window._selectedLotId = String(lot.lot_id);
        window.dispatchEvent(new CustomEvent('lot:select', { detail: { lotId: lot.lot_id, source: 'direct-url' } }));
        window.dispatchEvent(new CustomEvent('lot:focus', { detail: { lotId: lot.lot_id } }));
      }
    } catch (err) {
      console.error('[UI] Direct lot URL error:', err);
    }
  }

  if (window.map && window.map.isStyleLoaded && window.map.isStyleLoaded()) {
    handleDirectLotUrl();
  } else {
    window.addEventListener('map:ready', function() {
      handleDirectLotUrl();
    });
  }
})();
